/* eslint-disable no-underscore-dangle */
import { GetStaticProps } from 'next';
import sdk from '@src/lib/sdk';
import { DeepExtractTypeSkipArrays } from '@src/types/extract-types';
import { ServiceQuery } from '@src/generated/graphql';
import MyServices from '@components/MyServices/MyServices';

export async function getStaticPaths() {
  const { allServices } = await sdk.Services();
  return {
    paths:
      allServices?.map((service) => ({
        params: {
          slug: service.slug?.current,
        },
      })) || [],
    fallback: true,
  };
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  if (typeof params?.slug !== 'string') return Promise.resolve({ props: {} });

  const { allServices } = await sdk.Service({ slug: params.slug });

  return {
    props: {
      service: allServices[0],
    },
  };
};

const Services: React.FC<{
  service: DeepExtractTypeSkipArrays<ServiceQuery, ['allServices']>;
}> = ({ service }) => {
  // check if service exists!
  if (!service) return null;

  return <MyServices {...service} />;
};

export default Services;
